import { WebPortalService } from '../resource'

const PackageModule = {
  namespaced: true,
  state: {
    data: []
  },
  mutations: {
    SET_DATA (state, data) {
      state.data = data
    }
  },
  actions: {
    createData ({ commit, state }, data) {
        return WebPortalService.PackageCreate(data)
    },
    updateData ({ commit, state }, data) {
        return WebPortalService.PackageUpdate(data)
    },
    deleteData ({ commit, state }, data) {
        return WebPortalService.PackageDelete(data)
    },
    async listData ({ commit, state }) {
      try{

      
        const data = await WebPortalService.PackageList()
        if (data.data.Data == null) 
        {
          commit('SET_DATA', [])
        }
        else 
        {
          commit('SET_DATA', data.data.Data)
        }
      }
      catch
      {
        commit('SET_DATA', [])
      }
    }
  },
  getters: {
    getData (state) {
      return state.data
    }
  }
}

export default PackageModule